import { lazy } from "react";
import { DefaultLayout } from "../../layout";
import { withSuspense } from "../../routes/helpers";

const ManageWards = lazy(() => import("./ManageWards"));

const L = DefaultLayout;
const W = withSuspense;

export function getManageWardsRoutes() {
  return [
    { path: "/manageward/:id", layout: L, element: W(ManageWards) },
  ];
}
